import { components, createFilter } from "react-windowed-select";

export const customComponents = {
  ClearIndicator: props => (
    <components.ClearIndicator {...props}>X</components.ClearIndicator>
  )
};

export const customFilter = createFilter({ ignoreAccents: false });